angular.module('invoice')
    .component('invoiceBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/invoice/_btn-options.html',
        controller: function (InvoiceService, FilesLibrary, FilesSimpleUploadService, Principal) {
            this.InvoiceService = InvoiceService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.flags = [1, 2, 3, 4]

            this.$onInit = () => {
                Principal.currentUser().then(user => {
                    this.isWorker = this.item.worker.id === user.id
                })
                this.isAccountant = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING'])
                this.isManager = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ALL'])
            }

            this.isDocumentWritable = () => {
                return !InvoiceService.isDocumentTerminal(this.item)
            }

            this.canPass = () => {
                return this.isWorker || this.isAccountant || this.isManager
            }

            this.canEdit = () => {
                return this.isDocumentWritable() && (this.isWorker || this.isAccountant || this.isManager)
            }

            this.canDelete = () => {
                return this.isDocumentWritable() && (this.isWorker || this.isAccountant || this.isManager)
            }
        }
    })
